interface WeatherSummaryTooltipProps {
  modelLabel: string;
  time: string;
  temperature: number;
  precipitation: number;
  windSpeed: number;
}

export function WeatherSummaryTooltip({
  modelLabel,
  time,
  temperature,
  precipitation,
  windSpeed,
}: WeatherSummaryTooltipProps) {
  return (
    <div className="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 z-50 opacity-0 group-hover:opacity-100 transition-opacity">
      <div className="rounded-md shadow-lg px-2.5 py-2 text-xs bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 whitespace-nowrap">
        <div className="flex items-center justify-between gap-3">
          <span className="font-semibold text-gray-900 dark:text-gray-100">{modelLabel}</span>
          <span className="text-gray-500 dark:text-gray-400">{time}</span>
        </div>
        <div className="mt-1 grid grid-cols-2 gap-x-4 gap-y-0.5 text-gray-700 dark:text-gray-300">
          <div>Temp:</div>
          <div className="text-right font-semibold">{temperature}°</div>
          <div>Precip:</div>
          <div className="text-right font-semibold">{precipitation.toFixed(1)} mm/h</div>
          <div>Wind:</div>
          <div className="text-right font-semibold">{windSpeed.toFixed(1)} m/s</div>
        </div>
      </div>
    </div>
  );
}
